import * as React from 'react';
import { Filter } from '../../../domain/entities/Filter';
import { classes } from '../../../utils/Classes';
import { FilterItemWrapper } from '../FilterItemWrapper';

export interface IFilterItem {
    filter: Filter;
    ariaLabel: string;
    className?: string;
}

export class FilterItem extends React.Component<IFilterItem> {
    private onRemoveTag = () => {
        this.props.filter.setActiveState(false);
    };

    render() {
        const appliedFiltersClassnames = classes(
            'styled-filters-applied-filter',
            this.props.className
        );

        return (
            <FilterItemWrapper
                onClick={this.onRemoveTag}
                className={appliedFiltersClassnames}
                key={this.props.filter.key}
                ariaLabel={this.props.ariaLabel}
            >
                {this.props.filter.label}
            </FilterItemWrapper>
        );
    }
}
